import React from 'react';
import { withSessionSsr, getPublicToken } from "../../lib/sessionMiddleware";
import { getCanonicalPath } from "../../lib/canonical";
import useHook from '../../hooks/pages/tienda/useHook';
import styles from './styles.module.scss';
import {
  Navbar,
  Wrapper,
  TituloSeccion,
  Seccion,
  Footer,
  HeadTags,
  BtnFlotanteWhatsapp,
  ItemProductoV2,
  FiltrosTienda,
  SkeletonProducto,
  SinResultadosProductos,
}from '../../components';

import { CircularProgress } from '@mui/material';

const CANTIDAD_SKELETONS = 8;


const TiendaPage = (props)=>{

  const tipos = props.pageProps.tipos;
  const tematicas = props.pageProps.tematicas;
  const colores = props.pageProps.colores;
  const productosIniciales = props.pageProps.productosIniciales;

  const {
    tipo,
    handleTipo,
    tematica,
    handleTematica,
    color,
    handleColor,
    destacado,
    handleDestacado,
    novedad,
    handleNovedad,
    handleClearFiltros,
    loadingProductos,
    loadingMore,
    productos,
    totalPages,
    totalResults,
    sentinelRef,
    topRef,
  } = useHook({
    productos: productosIniciales,
    totalPages: props.pageProps.totalPagesIniciales,
    totalResults: props.pageProps.totalResultsIniciales,
  });

  const schema = productosIniciales?.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": productosIniciales.map((p, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "url": `${process.env.NEXT_PUBLIC_URL_FRONTEND}/productos/${p.attributes.slug}`,
      "name": p.attributes.nombre,
    })),
  } : null;

  return(<>

    <HeadTags
      title="Tienda"
      description="Buscá en nuestro catálogo online y encontrá lo que necesitas para festejar y decorar tu evento"
      path={props.pageProps.pathname}
      schema={schema}
    />


    <Navbar/>

    <Seccion padding="20px 20px">
      <Wrapper>
        <TituloSeccion align="center" hidden>Todos los productos de We Celebrate!</TituloSeccion>

        <div className={styles.layout}>

          <FiltrosTienda
            tipos={tipos}
            tematicas={tematicas}
            colores={colores}
            tipo={tipo}
            tematica={tematica}
            color={color}
            destacado={destacado}
            novedad={novedad}
            onChangeTipo={handleTipo}
            onChangeTematica={handleTematica}
            onChangeColor={handleColor}
            onToggleDestacado={handleDestacado}
            onToggleNovedad={handleNovedad}
            onClear={handleClearFiltros}
          />

          <div className={styles.content} ref={topRef}>

            {loadingProductos ?
              <div className={styles.contenedor}>
                {Array.from({ length: CANTIDAD_SKELETONS }).map((_, i) => (
                  <SkeletonProducto key={i} />
                ))}
              </div>
              :
              productos?.length > 0 ? <>
                <div className={styles.contenedor}>
                  {productos.map(item=>(
                    <ItemProductoV2 data={item} key={item.id}/>
                  ))}
                </div>

                <div ref={sentinelRef} className={styles.sentinel} />

                {loadingMore &&
                  <div className={styles.loadingMore}>
                    <CircularProgress size={28} color="secondary" />
                  </div>
                }
              </>
                :
                <SinResultadosProductos
                  hasActiveFiltros={!!(tipo.length || tematica.length || color.length || destacado || novedad)}
                  onClear={handleClearFiltros}
                />
            }

          </div>

        </div>

      </Wrapper>
    </Seccion>

    <br/><br/><br/>

    <Footer/>

    <BtnFlotanteWhatsapp/>
  </>);
};

export default TiendaPage;

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {

    const { req, query } = ctx;

    const publicToken = await getPublicToken(req);

    const fetchTipos = async()=>{
      try{
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/tipos/get-filtered`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
        });
        let data = await result.json();
        return (data?.data || []);
      }catch(err){
        console.log("e", err);
        return [];
      }
    };

    const fetchTematicas = async()=>{
      try{
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/tematicas/get-filtered`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
        });
        let data = await result.json();
        return (data?.data || []);
      }catch(err){
        console.log("e", err);
        return [];
      }
    };

    const fetchColores = async()=>{
      try{
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/colores/get-filtered`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
        });
        let data = await result.json();
        return (data?.data || []);
      }catch(err){
        console.log("e", err);
        return [];
      }
    };

    const fetchProductosIniciales = async()=>{
      try{
        const body = {
          liviano: true,
          page: 1,
          pageSize: 24,
          tipo: (query.tipo || '').toString().trim().split(',').filter(Boolean),
          tematica: (query.tematica || '').toString().trim().split(',').filter(Boolean),
          color: (query.color || '').toString().trim().split(',').filter(Boolean),
          destacado: query.destacado === '1',
          novedad: query.novedad === '1',
        };
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/productos/get-filtered`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
          body: JSON.stringify(body),
        });
        let data = await result.json();
        return {
          productos: data?.data || [],
          totalPages: Math.ceil((data?.meta?.pagination?.total || 0) / 24),
          totalResults: data?.meta?.pagination?.total || 0,
        };
      }catch(err){
        console.log("e", err);
        return { productos: [], totalPages: 0, totalResults: 0 };
      }
    };

    let tematicas = await fetchTematicas();
    let tipos = await fetchTipos();
    let colores = await fetchColores();
    let productosIniciales = await fetchProductosIniciales();

    return {
      props: {
        pathname: getCanonicalPath(req),
        tematicas: tematicas,
        tipos: tipos,
        colores: colores,
        productosIniciales: productosIniciales.productos,
        totalPagesIniciales: productosIniciales.totalPages,
        totalResultsIniciales: productosIniciales.totalResults,
      },
    };

  },
);
